export const validateCPF = (cpf) => {
  const regex = /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}-?[0-9]{2})$/;
  return regex.test(cpf);
};

export const formatCPF = (cpf) => {
  return cpf?.toString()
    .replace(/\D/g, '') // Remove qualquer caractere não numérico
    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o primeiro ponto
    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o segundo ponto
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2'); // Adiciona o traço
};